import { Injectable } from '@angular/core';
import { LoginService } from '../login/login-service/login.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Injectable({
    providedIn: 'root',
})
export class CheckTokensService {
    constructor(
        private loginService: LoginService,
        private readonly configService: ConfigService
    ) {}

    performCheck(): Promise<any> {
        return new Promise((resolve) => {
            const isUserLoggedInViaCookie = this.loginService.logInUserFromCookie();
            if (!isUserLoggedInViaCookie) {
                const customerID = localStorage.getItem('Customer_ID');
                // Below NOSONAR comment is to escape from SonarCloud Code Analysis
                const customerIdWithoutPrefix = customerID?.replace(
                    /.*?(\d+)/,
                    '$1'
                ); //NOSONAR
                if (!customerIdWithoutPrefix) {
                    resolve('error');
                } else {
                    const origin = this.configService.config.clientAuthUrl;
                    // Client Auth URL which routes to CheckTokens with customer id as route parameter
                    const url = `${origin}/CheckTokens/${customerIdWithoutPrefix}`;
                    const iframe = document.createElement('iframe');
                    iframe.style.display = 'none';
                    iframe.src = url;
                    document.body.appendChild(iframe);

                    const handleMessage = (event: MessageEvent) => {
                        if (event?.origin === origin) {
                            const { result, data } = event?.data;
                            if (
                                result === 'success' &&
                                data?.idToken &&
                                data?.accessToken &&
                                data?.refreshToken
                            ) {
                                this.loginService
                                    .logInUserFromSession(data?.idToken)
                                    .subscribe({
                                        complete: () => {
                                            this.removeHandlers(
                                                iframe,
                                                handleMessage
                                            );
                                            resolve(result);
                                        },
                                    });
                            } else {
                                this.removeHandlers(iframe, handleMessage);
                                resolve(result);
                            }
                        }
                    };

                    window.addEventListener('message', handleMessage);
                }
            } else {
                resolve('success');
            }
        });
    }

    private removeHandlers(
        iframe: HTMLIFrameElement,
        handleMessage: (event: MessageEvent) => void
    ) {
        window.removeEventListener('message', handleMessage);
        document.body.removeChild(iframe);
    }
}
